export default "/survey_assets/icons/check.15a7840aeae1e915bd6e2cc28a11b1fc.svg";